<template>
  <div class="modal false z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center">
    <div class="absolute w-full h-full bg-gray-900 opacity-50 modal-overlay"
         @click="$emit('close')"></div>
    <div class="z-50 w-11/12 mx-auto bg-white rounded shadow-lg modal-container md:max-w-3xl max-h-screen-9/10 custom-scrollbar overflow-y-auto">
      <div class="flex-auto">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <!-- header -->
          <div class="flex justify-between items-start p-5 rounded-t border-b dark:border-gray-600">
            <h3 class="text-lg font-semibold text-gray-900 lg:text-xl dark:text-white">
              Find User
            </h3>
            <button
                @click="$emit('close')"
                type="button"
                class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5
                ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">
              <XIcon class="w-5 h-5"/>
            </button>
          </div>
          <Form class="text-base leading-relaxed">
            <!-- body -->
            <div class="p-6">
              <div class="mb-4">
                <div class="mb-1">
                  <label class="block text-blue-400 text-sm" :for="`state-input`">
                    {{ $lang.app.SUBDIVISION }}
                  </label>
                </div>
                <div>
                  <Field :id="`state-input`"
                         :name="`state`" v-slot="{ field }">
                    <Multiselect
                        class="border border-blue-400"
                        v-bind="field"
                        v-model="state"
                        :options="helper.stateOptions"
                        :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                        valueProp="value"
                        :searchable="true"
                        :noOptionsText="$lang.app.LIST_EMPTY"
                        :noResultsText="$lang.app.NOT_FOUND">
                    </multiselect>
                  </Field>
                  <ErrorMessage :name="`state`" class="text-xs text-red-400"/>
                </div>
              </div>
              <div class="mb-4">
                <div class="mb-1">
                  <label class="block text-blue-400 text-sm" :for="`department-input`">
                    {{ $lang.app.DEPARTMENT }}
                  </label>
                </div>
                <div>
                  <Field :id="`department-input`"
                         :name="`department`" v-slot="{ field }">
                    <Multiselect
                        class="border border-blue-400"
                        v-bind="field"
                        v-model="department"
                        :options="helper.departmentOptions"
                        :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                        valueProp="value"
                        :searchable="true"
                        :noOptionsText="$lang.app.LIST_EMPTY"
                        :noResultsText="$lang.app.NOT_FOUND">
                    </multiselect>
                  </Field>
                  <ErrorMessage :name="`department`" class="text-xs text-red-400"/>
                </div>
              </div>
              <div class="mb-4">
                <div class="mb-1">
                  <label class="block text-blue-400 text-sm">
                    {{ $lang.app.EMPLOYEES }}
                  </label>
                </div>
                <div class="custom-scrollbar bg-blue-100 rounded-md p-3 h-48 overflow-y-auto">
                  <ul>
                    <li v-for="employee in helper.employeeOptions" :key="employee.id">
                      <div class="flex items-center justify-between my-1">
                        <div class="cursor-pointer" @click="choose(employee)">
                          <h5 class="leading-none text-gray-800">{{ employee.name }}</h5>
                          <p class="text-sm text-blue-800">{{ employee.position }}</p>
                        </div>
                        <button type="button" @click="toggleFavorites(employee)">
                          <StarIcon class="w-6 h-6"
                                    :class="[favorites.some(item => item.id === employee.id) ? 'text-indigo-700' : 'text-gray-400']"/>
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Field, Form, ErrorMessage} from 'vee-validate'

import stateApi from "../../../../api/ref/state"
import departmentApi from "../../../../api/employee/department"
import employeeApi from "../../../../api/employee/employee"

export default {
  props: {
    favorites: Array
  },
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  data() {
    return {
      state: null,
      department: null,
      helper: {
        stateOptions: [],
        departmentOptions: [],
        employeeOptions: [],
      },
    };
  },
  watch: {
    'state'(value) {
      if (value) {
        this.department = null
        this.setDepartmentOptions(value)
      }
    },
    'department'(value) {
      this.helper.employeeOptions = []
      if (value) {
        employeeApi.getDebugEmployeesByDepartmentId(value).then((res) => {
          this.helper.employeeOptions = res.data?.map((item) => ({
            id: item.id,
            name: item.fullName,
            position: this.$lang.$translate({ru: item.position.nameRu, kg: item.position.nameKg}),
          }));
        });
      }
    }
  },
  methods: {
    initStateOptions() {
      stateApi.getSubStates().then((res) => {
        this.helper.stateOptions = res.map(stateItem => ({
          value: stateItem.id,
          label: this.$lang.$translate({ru: stateItem.nameRu, kg: stateItem.nameKg}),
        }))
      })
    },
    setDepartmentOptions(value) {
      departmentApi.getActiveDepartmentsByStateId(value).then((res) => {
        this.helper.departmentOptions = res.map(departmentItem => ({
          value: departmentItem.id,
          label: this.$lang.$translate({ru: departmentItem.nameRu, kg: departmentItem.nameKg}),
        }))
      })
    },
    choose(employee) {
      this.$emit('choose', employee)
    },
    toggleFavorites(employee) {
      this.$emit('toggle-favorites', employee)
    }
  },
  beforeMount() {
    this.initStateOptions()
  },
}
</script>
